define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"csi/xml",
	"Sourcing"
], function(declare,Copy,xml,Sourcing) {

	return declare(Copy, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set the product on copy form
			this.inherited(arguments);

			var product = this.m_cache.getParentOfType(this.getParent(), ["Style", "Material", "Food", "FormulatedMaterial"]);
			if (product) {
				view.setProduct(product);
			} else {
				// must be on a Supplier Request.  get the Style / Material from the SRLineItemProduct
				product = this.m_cache.getPathNode(this.getNode(), "Child:QuoteSRLineItem/Child:SRLineItemProduct");
				if (product)
					view.setProduct(product);
			}
		},

		/**
		 * @override
		 * populate the popup params - isFDDEnabled to be reuse on SupplierItemForm and FoodSupplierItemForm
		 */
		onCreatePopupParams: function(params) {
			params.isFDDEnabled = this.isFDDEnabled();
		},

		/**
		 * @override
		 * Ensure that parent product is in the cache from either ProductSource or ProductSourcing level
		 * Add path to access factory node since its not in cache
		 */
		onDependencyPaths: function(paths) {
			paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSources");
			paths.push("Child:__Parent__/Child:SupplierFactory");
			paths.push("Child:__Parent__/Child:ColorSources");
		},

		toWriterFields: function(/*String*/urlNode, /*FormData?*/fd, /*Function*/filter) {
		    // swallow product type
		    fd = fd || this.m_formData; // in case form data isn't loaded yet

		    if (fd.getField("StyleType"))
		        fd.getFieldValue("StyleType", true);
		    if (fd.getField("MaterialType"))
		        fd.getFieldValue("MaterialType", true);
		    this.inherited(arguments);
		},

		postProcessSuccess: function() {
		    this.widget.refreshData();
		},

		/**
		 * @override
		 * Add generated name parameter to server operation
		 */
		toWriterRequest: function() {
			var	call = this.inherited(arguments);
			const supplierItemName = this.generateSupplierItemName();
			call.addParameter("Name", xml.ATTR_STRING, supplierItemName);

			return call;
		},

		/**
		 * Generate SupplierItem Name
		 */
		generateSupplierItemName(){
			const { m_cache } = this;
			const fd = this.m_formData;
			const isSupplierFactory = this.isFDDEnabled();
			const supplierItem = this.m_nodeSource;
			const productSource = m_cache.getNode(supplierItem.__Parent__);
			const sourceURL = isSupplierFactory ? productSource.SupplierFactory : productSource.Supplier;
			const sourceNode = m_cache.getNode(sourceURL);
			const source = xml.isValidURL(productSource.SupplierFactory) ? m_cache.getNode(sourceNode.Factory) : sourceNode;
			const sourceName = source?.$Name;
			const supplierQuoteName = fd.getFieldValue(xml.ATTR_NAME, true);
			const name = supplierQuoteName == "" ? sourceName : sourceName + " - " + supplierQuoteName;

			return name;
		},

		isFDDEnabled() {
			const node = this.getParent();
			const cache = this.m_cache;
			return Sourcing.isFDDEnabled(node, cache);
		}
	});
});